export const endpoints = {
  artworks: '/api/internal/artworks.json',
  artwork: (slug: string) => `/artworks/${slug}.json`,
  listings: (slateGroup: string) =>
    `/api/internal/slate_groups/${slateGroup}.json?slate_type=Artwork`,
};
